export default {"src":"/_next/static/media/gif.872c2404.gif","height":200,"width":200,"blurWidth":0,"blurHeight":0};